<template>
  <div>
    <div v-if="formHtml" v-html="formHtml"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: [
    'step',
  ],
  computed: mapGetters({
    formHtml: 'stepFormHtmlDecoded',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Email.vue?39e7e310
 **/